export default __webpack_public_path__ + "static/media/h10.717604e3.jpg";